import type { Node } from '@xyflow/react';
import type { NodeCategoryModel } from 'src/modules/network-configuration/models/node-data';
import type { NodeModel } from 'src/modules/network-configuration/models/node-model';

import { normalizeName, getPrimaryPortId } from './import-topology-shared';
import { invertPortIndexes } from './import-topology-utils';
import type { ImportContent } from './import-topology-utils';

/** Port on peer switch whose interface.name matches this switch's hostname (legacy getReciprocalPort). */
export function findReciprocalSwitchPortId(
  localSwitchName: string,
  peerSwitchId: string,
  switchNodes: Node<NodeModel>[],
  contentBySwitchId: Map<string, ImportContent>,
  fallbackPortId: string,
): string {
  const peerNode = switchNodes.find((n) => n.id === peerSwitchId);
  if (!peerNode) return fallbackPortId;
  const peerCat = peerNode.data.category as NodeCategoryModel;
  const peerContent = contentBySwitchId.get(peerSwitchId);
  if (!peerContent) return getPrimaryPortId(peerCat) || fallbackPortId;

  const inv = invertPortIndexes(peerCat.portIndexes || {});
  const want = normalizeName(localSwitchName);

  const interfaces = peerContent.data.interface?.interfaces ?? [];
  const found = interfaces.find((intf) => {
    if (!intf.up) return false;
    const name = (intf.name || '').trim();
    if (!name || normalizeName(name) !== want) return false;
    return Boolean(inv.get(intf.interface));
  });
  const portFromPeer = found ? inv.get(found.interface) : undefined;
  return portFromPeer || getPrimaryPortId(peerCat) || fallbackPortId;
}
